import { DocumentInfo } from 'api';
import { createContext, ReactNode } from 'react';

import { SalesOrderUpdateFormValues } from '../pages/SalesOrderUpdate/SalesOrderUpdate';
import { OrderFormVariant } from './OrderFormVariant';

type PurchaseOrderFormContextType = {
  variant: OrderFormVariant;
  defaultValues: SalesOrderUpdateFormValues | undefined;
  documents: DocumentInfo[];
};

export const SalesOrderFormContext = createContext<PurchaseOrderFormContextType>({
  defaultValues: undefined,
  documents: [],
  variant: undefined,
});

export const SalesOrderFormContextProvider = ({
  children,
  defaultValues,
  documents,
  variant,
}: {
  children: ReactNode;
  defaultValues: SalesOrderUpdateFormValues | undefined;
  variant: OrderFormVariant;
  documents: DocumentInfo[];
}) => {
  return (
    <SalesOrderFormContext.Provider value={{ defaultValues, documents, variant }}>
      {children}
    </SalesOrderFormContext.Provider>
  );
};
